import { useEffect } from 'react';
import { trackEvent } from '../lib/analytics';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'default';
}

export function LoadingSpinner({ message, size = 'default' }: LoadingSpinnerProps) {
  useEffect(() => {
    trackEvent('component_viewed', {
      component: 'LoadingSpinner',
      status: message ?? size,
    });
  }, [message, size]);

  return (
    <div className="flex flex-col items-center gap-3 p-6">
      <div className={`${size === 'small' ? 'size-5 border-2' : 'size-9 border-[3px]'} animate-spin rounded-full border-[var(--bg-primary-subtle)] border-t-[var(--fg-brand)]`} />
      {message && <p className="text-sm text-[var(--fg-secondary)]">{message}</p>}
    </div>
  );
}
